import {
  BillingMonthColumn,
  DetailsColumn,
  ToOrganizationNameColumn,
  TotalPriceColumn,
} from 'views/Billing/commonColumns';
import intl from 'react-intl-universal';
import { Button } from '@mui/material';
import {
  createBillingCSVContent,
  createDownloadLink,
  createCSVKenshinCSVContent,
} from '../shared/csv';
import PropTypes from 'prop-types';
import logger from 'utils/logger';

const log = logger.createLogger('SummaryTable');

//! TODO This function needs to be improved and refactored
export const DownloadColumn = (
  billData,
  billDataKenshin,
  doesHaveKenshinPermission
) => {
  const exportToCSV = (organizationId, organizationName, billingMonth) => {
    const selectedBillData = billData.find(
      (bill) =>
        bill.orgId === organizationId && bill.billedMonthYear === billingMonth
    );
    const filteredSelectedBillData = selectedBillData
      ? selectedBillData.bills
      : [];
    const csvFilename = `normal-bills-from-${organizationName}-${billingMonth}.csv`;
    const csvContent = createBillingCSVContent(filteredSelectedBillData, false);
    createDownloadLink(csvContent, csvFilename);
  };

  const exportToCSVKenshin = (
    organizationId,
    organizationName,
    billingMonth
  ) => {
    const selectedBillData = billDataKenshin.find(
      (bill) =>
        bill.orgId === organizationId && bill.billedMonthYear === billingMonth
    );
    const filteredSelectedBillData = selectedBillData
      ? selectedBillData.bills
      : [];

    const csvFilename = `kenshin-bills-from-${organizationName}-${billingMonth}.csv`;
    const csvContent = createCSVKenshinCSVContent(
      filteredSelectedBillData,
      false
    );
    createDownloadLink(csvContent, csvFilename);
  };

  return {
    accessorKey: 'download',
    header: intl.get('billing_for_sent_cases_label_column_download'),
    enableSorting: false,
    enableColumnFilter: false,
    enableColumnActions: false,
    Cell: ({ renderedCellValue }) =>
      downloadCell({
        renderedCellValue,
        exportToCSV,
        exportToCSVKenshin,
        doesHaveKenshinPermission,
      }),
  };
};

const downloadCell = ({
  renderedCellValue,
  exportToCSV,
  exportToCSVKenshin,
  doesHaveKenshinPermission,
}) => {
  const { organizationId, organizationName, billingMonth } = renderedCellValue;
  return (
    <div>
      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          exportToCSV(organizationId, organizationName, billingMonth);
        }}>
        {intl.get('billing_for_sent_cases_button_download_csv_seimitsu')}
      </Button>
      {doesHaveKenshinPermission && (
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            exportToCSVKenshin(organizationId, organizationName, billingMonth);
          }}>
          {intl.get('billing_for_sent_cases_button_download_csv_kenshin')}
        </Button>
      )}
    </div>
  );
};

downloadCell.propTypes = {
  renderedCellValue: PropTypes.object.isRequired,
  exportToCSV: PropTypes.func.isRequired,
  exportToCSVKenshin: PropTypes.func.isRequired,
  doesHaveKenshinPermission: PropTypes.bool.isRequired,
};

export const summaryTableColumns = (
  setSelectedDstOrgName,
  setSelectedDstOrgId,
  setSelectedBillingMonth,
  changeTableType,
  billData,
  billDataKenshin,
  doesHaveKenshinPermission
) => {
  return [
    BillingMonthColumn(),
    ToOrganizationNameColumn(),
    TotalPriceColumn(),
    DetailsColumn(
      setSelectedBillingMonth,
      setSelectedDstOrgName,
      setSelectedDstOrgId,
      changeTableType,
      doesHaveKenshinPermission
    ),
    DownloadColumn(billData, billDataKenshin, doesHaveKenshinPermission),
  ];
};

export const getSummaryTableData = (billData, billDataKenshin) => {
  const totalBillMap = new Map();
  // Merge both arrays into one
  const mergedBills = [...billData, ...billDataKenshin];
  mergedBills.forEach((bill) => {
    const { billedMonthYear, orgName, orgId, billedFee, startDate, endDate } =
      bill;

    const totalBill = totalBillMap.get(`${orgId}+${billedMonthYear}`);
    if (!totalBill) {
      totalBillMap.set(`${orgId}+${billedMonthYear}`, {
        billedMonthYear,
        startDate,
        endDate,
        orgName,
        orgId,
        billedFee,
      });
    } else {
      totalBillMap.set(`${orgId}+${billedMonthYear}`, {
        billedMonthYear,
        startDate,
        endDate,
        orgName,
        orgId,
        billedFee: totalBill.billedFee + billedFee,
      });
    }
  });

  const sortedTotalBillMap = Array.from(totalBillMap.values()).sort((a, b) => {
    const [monthA, yearA] = a.billedMonthYear.split('-');
    const [monthB, yearB] = b.billedMonthYear.split('-');
    return (
      parseInt(yearA) - parseInt(yearB) || parseInt(monthA) - parseInt(monthB)
    );
  });

  const data = [];
  sortedTotalBillMap.forEach((value) => {
    const { billedMonthYear, orgName, orgId, billedFee, startDate, endDate } =
      value;

    data.push({
      billingMonth: {
        startDate,
        endDate,
      },
      toOrganizationName: orgName,
      totalPrice: billedFee,
      details: {
        billingMonth: billedMonthYear,
        organizationName: orgName,
        organizationId: orgId,
      },
      download: {
        billingMonth: billedMonthYear,
        organizationName: orgName,
        organizationId: orgId,
      },
    });
  });

  return data;
};
